<template>
  <div class="btn-item">
    <template v-for="(item, index) in buttonList">
      <el-button
        v-if="item.type == '0'"
        :disabled="item.isDisabled"
        :key="index"
        @click="chooseClick(item.attributes.buttonUrl)"
        class="btn-save"
      >
        <svg-icon
          v-if="item.attributes.buttonStyle"
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          :icon-class="item.attributes.buttonStyle"
        />
        {{ item.label }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'index',
    props: {
      buttonList: {
        type: Array,
      },
    },
    methods: {
      chooseClick(item) {
        this.$emit('chooseClick', item);
      },
    },
  };
</script>

<style scoped></style>
